(function () {
  function initArkProCheckout() {
    var root = document.getElementById('arkpro-lp');
    if (!root || root.dataset.checkoutReady === 'true') return;
    root.dataset.checkoutReady = 'true';

    var selectedVariant = {
      id: Number(root.dataset.variantId || 0),
      title: '',
      price: '',
      inventory: Number(root.dataset.inventory || 0),
      available: root.dataset.available === 'true',
      checkoutHref: ''
    };
    var statusNodes = document.querySelectorAll('.checkout-status');
    var buyLinks = document.querySelectorAll('[data-buy-link]');
    var variantOptions = document.querySelectorAll('[data-variant-option]');
    var variantImages = document.querySelectorAll('[data-variant-image]');
    var greenAssetsPreloaded = false;

    function setStatus(message) {
      statusNodes.forEach(function (node) { node.textContent = message; });
    }

    function inventoryMessage() {
      if (!selectedVariant.available) return selectedVariant.title + ' is currently restocking';
      var count = selectedVariant.inventory > 0 ? ' · ' + selectedVariant.inventory + ' available' : '';
      return 'In stock at Rarely' + count + ' · Free shipping · Secure checkout';
    }

    function preloadGreenAssets() {
      if (greenAssetsPreloaded) return;
      greenAssetsPreloaded = true;
      var seen = {};
      variantImages.forEach(function (image) {
        var source = image.dataset.greenSrc || '';
        if (!source || seen[source]) return;
        seen[source] = true;
        var preload = new Image();
        preload.src = source;
      });
    }

    function renderSelection(option, updateUrl) {
      selectedVariant = {
        id: Number(option.dataset.variantId || 0),
        title: option.dataset.variantTitle || '',
        price: option.dataset.variantPrice || '',
        inventory: Number(option.dataset.variantInventory || 0),
        available: option.dataset.variantAvailable === 'true',
        checkoutHref: option.dataset.variantCheckoutHref || ''
      };

      root.dataset.variantId = String(selectedVariant.id);
      root.dataset.available = String(selectedVariant.available);
      root.dataset.inventory = String(selectedVariant.inventory);

      variantOptions.forEach(function (node) {
        node.setAttribute('aria-pressed', String(node === option));
      });
      document.querySelectorAll('[data-selected-title]').forEach(function (node) { node.textContent = selectedVariant.title; });
      document.querySelectorAll('[data-selected-price]').forEach(function (node) { node.textContent = selectedVariant.price; });
      document.querySelectorAll('[data-selected-stock-copy]').forEach(function (node) { node.textContent = inventoryMessage(); });
      document.querySelectorAll('[data-mobile-action]').forEach(function (node) { node.textContent = selectedVariant.available ? 'Checkout ↗' : 'Unavailable'; });
      var isOliveGreen = selectedVariant.title.indexOf('Olive Green') !== -1;
      document.querySelectorAll('[data-selected-color-short]').forEach(function (node) { node.textContent = isOliveGreen ? 'OLIVE GREEN' : 'ONYX BLACK'; });
      variantImages.forEach(function (image) {
        var nextSource = isOliveGreen ? image.dataset.greenSrc : image.dataset.blackSrc;
        var nextAlt = isOliveGreen ? image.dataset.greenAlt : image.dataset.blackAlt;
        if (nextSource && image.getAttribute('src') !== nextSource) image.setAttribute('src', nextSource);
        if (nextAlt) image.alt = nextAlt;
      });

      buyLinks.forEach(function (link) {
        var label = link.querySelector('[data-buy-label]');
        var prefix = link.dataset.buyPrefix || '';
        link.href = selectedVariant.available ? selectedVariant.checkoutHref : '#availability';
        link.classList.toggle('is-disabled', !selectedVariant.available);
        if (label) label.textContent = selectedVariant.available ? prefix + ' · ' + selectedVariant.price : selectedVariant.title + ' unavailable';
      });

      setStatus('');
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(selectedVariant.id));
        window.history.replaceState({}, '', url.toString());
      }
    }

    variantOptions.forEach(function (option) {
      option.addEventListener('click', function () { renderSelection(option, true); });
      if ((option.dataset.variantTitle || '').indexOf('Olive Green') !== -1) {
        option.addEventListener('mouseenter', preloadGreenAssets, { once: true });
        option.addEventListener('focus', preloadGreenAssets, { once: true });
        option.addEventListener('touchstart', preloadGreenAssets, { once: true, passive: true });
      }
      if (Number(option.dataset.variantId || 0) === selectedVariant.id) renderSelection(option, false);
    });

    buyLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!selectedVariant.id || !selectedVariant.available) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        if (link.dataset.loading === 'true') return;

        link.dataset.loading = 'true';
        link.setAttribute('aria-busy', 'true');
        setStatus('Preparing secure checkout…');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity: 1 }] })
        })
          .then(function (response) {
            if (response.ok) return response.json();
            return response.json().then(function (data) {
              throw new Error(data.description || data.message || 'This item could not be added.');
            });
          })
          .then(function () {
            window.location.assign('/checkout');
          })
          .catch(function (error) {
            link.dataset.loading = 'false';
            link.removeAttribute('aria-busy');
            setStatus(error.message || 'This item could not be added. Please try again.');
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArkProCheckout, { once: true });
  } else {
    initArkProCheckout();
  }
})();
